import { render, staticRenderFns } from "./HeaderGroupDropdown.vue?vue&type=template&id=0b35a663&scoped=true"
import script from "./HeaderGroupDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderGroupDropdown.vue?vue&type=script&lang=js"
import style0 from "./HeaderGroupDropdown.vue?vue&type=style&index=0&id=0b35a663&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b35a663",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b35a663')) {
      api.createRecord('0b35a663', component.options)
    } else {
      api.reload('0b35a663', component.options)
    }
    module.hot.accept("./HeaderGroupDropdown.vue?vue&type=template&id=0b35a663&scoped=true", function () {
      api.rerender('0b35a663', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/header/Buttons/HeaderGroupDropdown.vue"
export default component.exports